(() => {
  // Pricing toggle
  const priceToggleEl = document.querySelector('.js-price-toggle');
  if (!priceToggleEl) {
    return;
  }
  const monthly = priceToggleEl.querySelector('.monthly');
  const annual = priceToggleEl.querySelector('.annual');
  const highlight = priceToggleEl.querySelector('.highlight');
  const monthlyAmount = document.querySelector('.js-price-block__price-item.monthly');
  const annualAmount = document.querySelector('.js-price-block__price-item.annual');

  priceToggleEl.addEventListener('click', () => {
    if (monthly.classList.contains('active')) {
      monthly.classList.remove('active');
      annual.classList.add('active');
      highlight.classList.remove('monthly');
      highlight.classList.add('annual');
      setTimeout(() => {
        annualAmount.classList.remove('hide-fast');
        annualAmount.classList.add('show-fast');
      }, 200);
      monthlyAmount.classList.add('hide-fast');
      monthlyAmount.classList.remove('show-fast');
    } else {
      annual.classList.remove('active');
      monthly.classList.add('active');
      highlight.classList.remove('annual');
      highlight.classList.add('monthly');
      annualAmount.classList.add('hide-fast');
      annualAmount.classList.remove('show-fast');
      setTimeout(() => {
        monthlyAmount.classList.remove('hide-fast');
        monthlyAmount.classList.add('show-fast');
      }, 200);
    }
  });
})();
